import { Typography } from '@hulu/react-style-components';
import styled, { css } from 'styled-components';

export const SectionLabelStyled = styled(Typography).attrs({ variant: 'body2' })`
  color: ${({ theme }): string => theme.admanColors!.gray.light.fg[1]};
  font-weight: 500;

  .TrekLabel-root {
    color: inherit;
  }
`;

export const SIDEBAR_FOOTER = css(
  ({ theme: { spacers, admanColors } }) => `
    display: flex;
    width: 100%;
    position: absolute;
    height: ${spacers!.spacer12};
    box-shadow: 0 -1px 8px 0 rgb(19 32 57 / 10%);
    bottom: 0;
    left: 0;
    padding: ${spacers!.spacer04} ${spacers!.spacer06} ${spacers!.spacer04}
      ${spacers!.spacer06};
    background-color: ${admanColors!.gray.light.bg0[0]};
    gap: ${spacers!.spacer04};
  `
);
